
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Créteil dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Créteil certifiée Google Partner, accompagne les entreprises cristoliennes pour développer leur visibilité en ligne et trouver de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Créteil dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Créteil certifiée Google Partner, accompagne les entreprises cristoliennes pour développer leur visibilité en ligne et trouver de nouveaux clients.",
        },
      ],
    };
  },
};
